import { FC, PropsWithChildren, ReactElement } from 'react';
import { Button, Divider, Loader } from '@kl/components-v6';
import { Menu } from '@kl/hexa-ui-icons/24';
import { ArrowDown1 } from '@kl/icons/16';
import { Header } from 'shared/ui/header';
import { ContentContainer } from '../styled-components';
import { MainContainer, StyledTitleContainer } from './styled';
import { KscLogo } from './KSCLogo';
import { ChangeLanguage } from '../change-language';
import { Locale } from '../locale';
import { Footer } from '../footer/Footer';
import { useInitialInfo } from 'shared/api/use-initial-info';

interface EnterprisePortalLayoutProps {
    headerDesktopMenu?: ReactElement;
    headerMobileMenu?: ReactElement;
}

const DefaultHeaderMenu = (
    <ChangeLanguage trigger="hover">
        <Button mode="secondary" testId="changeLanguageDropdown">
            <StyledTitleContainer>
                <Locale localizationKey="ChangeLanguage" />
                <ArrowDown1 />
            </StyledTitleContainer>
        </Button>
    </ChangeLanguage>
);

const DefaultMobileMenu = (
    <ChangeLanguage trigger="click">
        <Button iconBefore={<Menu />} mode="tertiary" testId="changeLanguageDropdown" />
    </ChangeLanguage>
);

export const EnterprisePortalLayout: FC<PropsWithChildren<EnterprisePortalLayoutProps>> = ({
    children,
    headerDesktopMenu = DefaultHeaderMenu,
    headerMobileMenu = DefaultMobileMenu,
}) => {
    const { isKscMode, isFetching } = useInitialInfo();

    if (isFetching) {
        return <Loader centered size="large" />;
    }

    return (
        <>
            <Header
                desktopMenu={headerDesktopMenu}
                logo={<KscLogo />}
                mobileMenu={headerMobileMenu}
            />
            <MainContainer>
                <ContentContainer>{children}</ContentContainer>
            </MainContainer>
            <ContentContainer>
                <Divider />
                <Footer isKscMode={isKscMode} />
            </ContentContainer>
        </>
    );
};
